import React from 'react';
import classnames from 'classnames';

import { Feature } from '@react/Pages/AccountSettingsPage/PricingPlanPage/features';

import './PricingPlanFeatures.scss';

export interface PricingPlanFeaturesProps {
  features: Feature[];
  isYearly?: boolean;
}

export const PricingPlanFeatures = ({ features, isYearly }: PricingPlanFeaturesProps) => (
  <div className="pricing-plan-features">
    <h2 className="pricing-plan-features__title">{t('label.features')}</h2>

    <div className="pricing-plan-features__features-list">
      <div className="flex-box-column flex-justify-center pricing-plan-features__feature">{t('label.clicks')}</div>
      <div className="flex-box-column flex-justify-center pricing-plan-features__feature">
        {t('feature.organic-installs')}
      </div>
      <div className="flex-box-column flex-justify-center pricing-plan-features__feature">
        {t('feature.in-app-events')}
      </div>
      <div className="flex-box-column flex-justify-center pricing-plan-features__feature">
        {t('pricing-plan.included-attributions')}
      </div>
      <div
        className={classnames('flex-box-column', 'flex-justify-center', 'pricing-plan-features__feature', {
          'pricing-plan-features__feature--yearly': isYearly,
        })}
      >
        {t('pricing-plan.additional-attributions')}
      </div>
      {features.map(({ key, label }) => (
        <div className="flex-box-column flex-justify-center pricing-plan-features__feature" key={key}>
          {label}
        </div>
      ))}
      <div className="flex-box-column flex-justify-center pricing-plan-features__feature">
        {t('pricing-plan.monthly-fee')}
      </div>
    </div>
  </div>
);
